module.exports = __webpack_public_path__ + "static/media/headphones.7496e469.png";